module.exports = __webpack_public_path__ + "img/eg.662494cb.svg";